import React from 'react';
import  '../../../css/AddTripForm/Element.css';
import FormField from '../FormField';
const IndividualTransport = ({ data, handleChange }) => {

  const isLinked = data.variants.lenght > 1;
  return (
    <div className="transportContainer">

      <FormField
        label="Nazwa"
        name="name"
        type="text"
        value={data.name || ""}
        onChange={(field, value) => handleChange(field, value)}
        required
  />
        <FormField
        label="Opis"
        name="description"
        type="richtext"
        value={data.description || ""}
        onChange={(field, value) => handleChange(field, value)}
        placeholder="Aby użyć link wpisz dowolny tekst (np. Klik) a następnie go zaznacz i wybierz ostatni symbol z paska narzędzi. To pozwoli Ci wpisać link."
  />

<FormField
    label="Czas rozpoczęcia"
    name="startDate"
    type="datetime-local"
    value={data.startDate || ''}
    onChange={(field, value) => handleChange(field, value)}
    required
  />

<FormField
    label="Link"
    name="link"
    type="text"
    value={data.link || ''}
    onChange={(field, value) => handleChange(field, value)}
  />

    </div>
  );
};

export default IndividualTransport;
